export default __webpack_public_path__ + "static/media/5_Stellungnahme Medibuero.1025cb6f.pdf";